import React from "react";
import AllJobs from "./Job/AllJobs";
import DraftJobs from "./Job/DraftJobs";
import AddNewJobPost from "./Job/AddNewJobPost";
import JobBoards from "./Job/JobBoards";
import { NewTab, PageTabAdv } from "../../../components";
import { useModuleAccess } from "../../../hooks";
import MyJobsNew from "./Job/MyJobsNew";
import AiRecruiterJobs from "./Job/AiRecruiterJobs";

const Jobs = () => {
  const JobMenus = [
    {
      title: "All Jobs",
      page: <AllJobs />,
      type: "main",
      id: "jobs_alljobs",
    },
    {
      title: "My Jobs",
      page: <MyJobsNew />,
      type: "main",
      id: "jobs_myjobs",
    },
    {
      title: "Draft Jobs",
      page: <DraftJobs />,
      type: "main",
      id: "jobs_draftjobs",
    },
    {
      title: "Add New Job Post",
      page: <AddNewJobPost />,
      type: "main",
      id: "jobs_addnewjobpost",
    },
    {
      title: "Job Boards",
      page: <JobBoards />,
      type: "main",
      id: "jobs_jobboards",
    },
    {
      title: "AI Recruiter Jobs",
      page: <AiRecruiterJobs />,
      type: "main",
      disabled: true,
      id: "jobs_airecruiterjobs",
    },
  ];
  const filteredTabs = useModuleAccess({ allTabs: JobMenus, parentId: "jobs" });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="jobs"
    />
  );
};

export default Jobs;
